

var logFatalFunction = null;

// IMPORTANT : must match the LogCategory values from settings.js !!!
export var LogCategory = {
    startup: {name: "startup",log: true},
    info: {name: "info",log: false},
    warn: {name: "warn",log: false},
    error: {name: "ERROR",log: true},
    fatal: {name: "FATAL",log: true},
    initializeData: {name: "initialize",log: false},
    initialState: {name: "initialState",log: false},
    newUser: {name: "newUser",log: true},
    expires: {name: "expires",log: false},
    product: {name: "product",log: false},
    price: {name: "price",log: false},
    callback: {name: "callback",log: false},
    postInitialCall: {name: "postInitialCall",log: false},

    clientCall: {name: "clientCall",log: false},
    rawApiCallHeaders: {name: "rawApiCAllHeaders",log: false},
    rawApiCall: {name: "rawApiCall",log: false},
    rawApiPostBody: {name: "rawApiPostBody",log: false},
    rawApiCallAnswer: {name: "rawApiCallAnswer",log: false},
    purchase: {name: "purchase",log: false},

    restriction: {name: "restriction",log: false},
};

var logFormattedJson = false;

function doLog(msg, severity, json_extra) {
    console.log(severity + " : " + msg);
}

// example: log(LogCategory.info, "titi");
//
// 4 may 2020 : json_extra - extra info that is to be interpreted as json; for now, only used for critical errors
export const log = function(category, msg, json_extra) {
    if ( category.log) {
        if ( category.name != "FATAL")
            doLog(msg, category.name, json_extra);
        else
            logFatal(msg, json_extra);
    }
};


const logFatal = function(msg, json_extra) {
    if ( logFatalFunction == null)
        doLog(msg + json_extra, "FATAL");
    else {
        if ( json_extra !== undefined)
            logFatalFunction(msg, json_extra);
        else 
            logFatalFunction(msg, {extra : ""});
            /*
        if ( json_extra !== undefined)
            logFatalFunction(msg, JSON.stringify(json_extra, null, 2));
        else 
            logFatalFunction(msg, "");*/
    }
};

export const setFatalFunction = function(f) {
    logFatalFunction = f;
};

export const getJson = function(s) {
    return logFormattedJson ? JSON.stringify(s, null, 2) : JSON.stringify(s);
};

export const logJsonAsFormatted = function(b) {
    logFormattedJson = b;
};

export const setLogCategory = function(lc) {
    LogCategory = lc;
};




// WEBPACK FOOTER //
// ./src/api/logger.js